var chunkMapping = {
	"404": [
		5404
	],
	"924": [
		2924
	]
};
var idToExternalAndNameMapping = {
	"2924": [
		"default",
		"./Store",
		6746
	],
	"5404": [
		"default",
		"./Payments",
		9594
	]
};
var idToRemoteMap = {
	"2924": [
		{
			"externalType": "script",
			"name": "store"
		}
	],
	"5404": [
		{
			"externalType": "script",
			"name": "payments"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"2924": {
		"shareScope": "default",
		"name": "./Store",
		"externalModuleId": 6746,
		"remoteName": "store"
	},
	"5404": {
		"shareScope": "default",
		"name": "./Payments",
		"externalModuleId": 9594,
		"remoteName": "payments"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}